import { createSelector } from 'reselect';

/**
 * Direct selector to the languageToggle state domain
 */
const selectNotifications = (state) => state.get('notifications');

/**
 * Select the language locale
 */

const makeSelectMessages = () =>
  createSelector(selectNotifications, (notificationsState) =>
    notificationsState.get('messages'),
  );
const makeSelectOpenMenu = () =>
  createSelector(selectNotifications, (notificationsState) =>
    notificationsState.get('openMenu'),
  );

export { selectNotifications, makeSelectMessages, makeSelectOpenMenu };
